import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreComponentsModule } from '@lx/core/components';
import { CurrencySelectorComponent } from '@lx/currency/currency-selector/currency-selector.component';
import {
  AccommodationComponentsModule,
  CourseComponentsModule,
  DateListSelectorComponent,
  DateOfBirthFieldComponent,
  DatePickerFieldComponent,
  DestinationComponentsModule,
  FormErrorMessageComponent,
  FormFieldSelectorComponent,
  LanguageComponentsModule,
  PhoneNumberFieldComponent,
  QuoteComponentsModule,
  QuoteToolSharedModule,
  SchoolComponentsModule,
  TitleSelectorComponent,
  WeeksSelectorComponent,
} from '@lx/quote-tool/shared/ui/components';
import {
  BlockSpacesDirective,
  FormDataAutofillDetectorDirective,
  FormDataCustomComponentValidityDirective,
  FormDataDropdownValidityDirective,
  FormDataEmailValidityDirective,
  FormDataInputValidityDirective,
  FormDataPostcodeValidityDirective,
} from '@lx/quote-tool/shared/ui/directives';
import { EmailErrorPipe } from '@lx/quote-tool/shared/ui/pipes';
import { ButtonComponent } from '@lx/shared/ui/button';
import { FormFieldComponent } from '@lx/shared/ui/form-field';
import { LoadingSpinnerComponent } from '@lx/shared/ui/loading-spinner';
import { DatePipe, PricePipe, SortByPipe } from '@lx/shared/ui/pipes';
import { UiModule } from '@lx/ui/components';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccommodationDatesFormSectionComponent } from './components/sections/accommodation-dates/accommodation-dates.component';
import { ContactPersonSectionComponent } from './components/sections/contact-person/contact-person.component';
import { CourseDatesFormSectionComponent } from './components/sections/course-dates/course-dates.component';
import { DestinationSchoolFormSectionComponent } from './components/sections/destination-school/destination-school.component';
import { ExtrasSelectionComponent } from './components/sections/extras-selection/extras-selection.component';
import { HostFamilySelectionComponent } from './components/sections/extras-selection/host-family-selection/host-family-selection.component';
import { SectionTemplateComponent } from './components/sections/section-template/section-template.component';
import { SelectOptionsFormSectionComponent } from './components/sections/select-options/select-options.component';
import { TellUsAboutYouSectionComponent } from './components/sections/tell-us-about-you/tell-us-about-you.component';
import { TermsAndPromotionsFormSectionComponent } from './components/sections/terms-and-promotions/terms-and-promotions.component';
import { BookingFormComponent } from './components/steps/booking-form/booking-form.component';
import { ConfirmationComponent } from './components/steps/confirmation/confirmation.component';
import { EnrolmentPaymentComponent } from './components/steps/enrolment-payment/enrolment-payment.component';
import { FlywirePaymentComponent } from './components/steps/flywire-payment/flywire-payment.component';
import { QuoteErrorComponent } from './components/steps/quote-error/quote-error.component';
import { PriceRequestFormComponent } from './components/steps/quote-form/price-request-form/price-request-form.component';
import { QuoteFormComponent } from './components/steps/quote-form/quote-form.component';
import { SendQuoteToEmailComponent } from './components/steps/send-quote-to-email/send-quote-to-email.component';
import { FormComponent } from './form.component';
import { OptionalPriceDurationPipe, SupplementDurationUnitPipe } from './pipes';
import { QuoteToolFormRoutingModule } from './routing/form-routing.module';
import { CourseSupplementComponent, LevelSelectorComponent } from './shared/components';

@NgModule({
  declarations: [
    FormComponent,
    QuoteFormComponent,
    BookingFormComponent,
    SendQuoteToEmailComponent,
    ConfirmationComponent,
    QuoteErrorComponent,
    DestinationSchoolFormSectionComponent,
    CourseDatesFormSectionComponent,
    AccommodationDatesFormSectionComponent,
    TellUsAboutYouSectionComponent,
    SelectOptionsFormSectionComponent,
    ContactPersonSectionComponent,
    ExtrasSelectionComponent,
    SelectOptionsFormSectionComponent,
    LevelSelectorComponent,
    EnrolmentPaymentComponent,
    FlywirePaymentComponent,
  ],
  exports: [FormComponent, SectionTemplateComponent, TellUsAboutYouSectionComponent, TermsAndPromotionsFormSectionComponent],
  imports: [
    CommonModule,
    CoreComponentsModule,
    QuoteToolFormRoutingModule,
    QuoteToolSharedModule,
    FormsModule,
    SchoolComponentsModule,
    CourseComponentsModule,
    LanguageComponentsModule,
    DestinationComponentsModule,
    QuoteComponentsModule,
    AccommodationComponentsModule,
    CurrencySelectorComponent,
    UiModule,
    ButtonComponent,
    SortByPipe,
    PricePipe,
    DatePipe,
    BlockSpacesDirective,
    InputTextareaModule,
    CheckboxModule,
    InputTextModule,
    LoadingSpinnerComponent,
    WeeksSelectorComponent,
    DateListSelectorComponent,
    DatePickerFieldComponent,
    FormFieldSelectorComponent,
    FormFieldComponent,
    DateOfBirthFieldComponent,
    HostFamilySelectionComponent,
    SectionTemplateComponent,
    TermsAndPromotionsFormSectionComponent,
    TitleSelectorComponent,
    FormErrorMessageComponent,
    FormDataDropdownValidityDirective,
    FormDataInputValidityDirective,
    FormDataEmailValidityDirective,
    PhoneNumberFieldComponent,
    FormDataPostcodeValidityDirective,
    FormDataAutofillDetectorDirective,
    PriceRequestFormComponent,
    EmailErrorPipe,
    OptionalPriceDurationPipe,
    SupplementDurationUnitPipe,
    FormDataCustomComponentValidityDirective,
    CourseSupplementComponent,
  ],
})
export class QuoteToolFormModule {}
